import { Button } from "@mui/material";
import classNames from "classnames";
import React, { memo } from "react";
import styles from "./Button.module.scss";

const Input = (props) => {
  const { variant = "filled" } = props;
  return (
    <Button
      {...props}
      size={props.size ?? "small"}
      variant={props?.variant ?? "contained"}
      sx={{
        boxShadow: "none",
        borderRadius: "6px",
        border: "1px solid #6570FC",
        fontWeight: "500 !important",
        fontFamily: "'DM Sans',Arial !important",
        "&:hover": {
          boxShadow: "none",
        },
        "&:active": {
          boxShadow: "none",
        },
        "&:focus": {
          boxShadow: "none",
        },
      }}
      // className={classNames(variant === "filled" ? styles.buttonContainer : styles.outlined, props?.className)}
      className={classNames(styles.buttonContainer, props?.className)}
    >
      {props?.children}
    </Button>
  );
};

export default memo(Input);
